var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCmsTransactions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "138.04 272.8 104.33 272.8 104.33 137.24 394.97 137.24 394.97 170.94 138.04 170.94 138.04 272.8",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.67 154.08 381.04 72 381.04 236.17 471.67 154.08",
    fill: "#818181"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "437.96 303.2 471.67 303.2 471.67 438.76 181.03 438.76 181.03 405.06 437.96 405.06 437.96 303.2",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.33 421.92 194.96 504 194.96 339.83 104.33 421.92",
    fill: "#818181"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmsTransactions);
export default __webpack_public_path__ + "static/media/CMS_Transactions.0399600f5a3a4fa87a28a380c50d3b29.svg";
export { ForwardRef as ReactComponent };